module.exports = __webpack_public_path__ + "static/media/weld_inspect_4.5a4a0385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_inspect_4.jpg
// module id = 1873
// module chunks = 0